const changes = [
  {
    "type": "bugfix",
    "description": "Made profile delete work\n"
  }
];

export default changes;
